/** @jsxRuntime classic */
/** @jsx createElement */

export function createDefaultFallbackComponent() {
  return function DefaultFallback() {
    return null;
  };
}